export default __webpack_public_path__ + "static/media/LineosoftArticleDashboard-min.277f3d3b.PNG";